import { useState } from 'react';
import PaymentComponent from './PaymentComponent';
import GooglePlayPaymentComponent from './GooglePlayPaymentComponent';
//import TestPlayPaymentComponent from './TestVip'; - не используется
import styles from './PaymentComponent.module.css';
import { useAppConfig } from '../../context/AppConfigContext';

const BuyButton = ({ tariff = 1, tariffConfig, isNative = false, isBrowser = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useAppConfig();

  const handleOpen = () => {
    if (!isModalOpen) setIsModalOpen(true);
  };
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <button onClick={handleOpen} className={styles.buyButton}>
        {t.payment.buy}
      </button>

      {isModalOpen && (
        <div className={styles.overlay}>
          {isNative ? (
            <GooglePlayPaymentComponent tariff={tariff} tariffConfig={tariffConfig} onClose={handleClose} />
          ) : (
            <PaymentComponent tariff={tariff} tariffConfig={tariffConfig} isBrowser={isBrowser} onClose={handleClose} />
          )}
        </div>
      )}
    </>
  );
};

export default BuyButton;

// вызывается из Premium

/*
<TestPlayPaymentComponent tariff={tariff} tariffConfig={tariffConfig} onClose={handleClose} />
*/